import { update } from "./API";

export const UpdateTfsSrpYearRate = async (
  tfs_srp_year_rate_id: number,
  payload: any
) => {
  try {
    return await update(
      `${process.env.REACT_APP_API_URL}/tfs-srp-year-rates/${tfs_srp_year_rate_id}`,
      payload
    );
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
